(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['underscore', './applicationUtils'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    module.exports = factory(require('underscore'), require('./applicationUtils'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(_, applicationUtils) {
  'use strict';

  var baseRestUrl = applicationUtils.currentApplication.baseRestUrl;
  var baseSecureRestUrl = applicationUtils.currentApplication.baseSecureRestUrl;
  var currentApplication = applicationUtils.currentApplication;
  var paymentRedirectUrl = currentApplication.fullUrlPath;

  /**
   * This contains the urls roots used by the app.
   * @class Urls
   * @static
   */
  return {
    /**
     * @property base {String} url to use for RESTful resources that are not secure.
     */
    base: baseRestUrl,
    /**
     * @property baseSecure {String} url to use for RESTful resources that are secure.
     */
    baseSecure: baseSecureRestUrl,
    /**
     * @property accountExtService {String} url
     */
    accountExtService: baseSecureRestUrl + '/account',
    /**
     * @property adminUserExtService {String} url
     */
    adminUserExtService: baseSecureRestUrl + '/user/admin',
    /**
     * @property apiUserExtService {String} url
     */
    apiUserExtService: '/authentication-service/api-user',
    /**
     * @property appointmentConfigurationExtService {String} url to use for the appointmentConfigurationExtService.
     */
    appointmentConfigurationExtService: '/appointment',
    /**
     * @property appointmentTypeExtService {String} url
     */
    appointmentTypeExtService: '/appointment/appointmentType',
    /**
     * @property appointmentInsuranceExtService {String} url
     */
    appointmentInsuranceExtService: baseSecureRestUrl + '/appointmentInsurance',
    /**
     * @property appointmentExtService {String} url
     */
    appointmentExtService: baseSecureRestUrl + '/appointment',
    /**
     * @property appointmentClassificationExtServiceTemplate {String} The url template for the appointment classification endpoint.
     */
    appointmentClassificationExtServiceTemplate: _.template(baseSecureRestUrl + '/kioskGroup/<%= kioskGroupId %>/appointmentClassification'),
    /**
     * @property appointmentTypeImportExportService {String} url for import/export of appointment types
     */
    appointmentTypeImportExportService: '/appointment/import-export',
    /**
     * @property authenticationFeatureConfigExtService {String} url
     */
    authenticationFeatureConfigExtService: '/authentication-service/config',
    /**
     * @property secure {String} url to use for RESTful resources that deal with sensitive data.
     */
    secure: baseSecureRestUrl,
    /**
     * @property clinicExtService {String} url to use for the ClinicExtService.
     */
    clinicExtService: baseSecureRestUrl + '/admin/clinics',

    /**
     * @property conversationExtService {String} url to use for the ConversationExtService.
     */
    conversationExtService: baseSecureRestUrl + '/conversation',
    /**
     * @property dataGeneratorConfigImportExportService {String} url for import/export of data generator configs
     */
    dataGeneratorConfigImportExportService: '/data-generator/ws/import-export',
    /**
     * @property demographicsExtService {String} url to use for the DemographicsExtService.
     */
    demographicsExtService: baseSecureRestUrl + '/demographics',
    /**
     * @property demographicsFeatureConfigService {String} url to use for the DemographicsFeatureConfigService.
     */
    demographicsFeatureConfigService: baseSecureRestUrl + '/demographics/config',
    /**
     * @property documentExtService {String} url to use for the DocumentExtService
     */
    documentExtService: baseSecureRestUrl + '/document',
    /**
     * TODO: Remove this when financialFeatureService is completely migrated to microservice
     * @property financialFeatureConfigService {String} url to use for the FinancialFeatureConfigService.
     * @deprecated new fields should not be getting added to this. Instead use billingConfigModel(financial microservice)
     */
    financialFeatureConfigService: baseSecureRestUrl + '/financial/config',
    /**
     * @property billingService {String} url to use for the Billing service.
     */
    billingConfigService: '/billing',
    /**
     * @property billingImportExportService {String} url to use for the ImportExportService.
     */
    billingImportExportService: '/billing/import-export',
    /**
     * @property dynamicFlagExtService {String} url for DynamicFlagExtService
     */
    dynamicFlagExtService: baseSecureRestUrl + '/flag',
    /**
     * @property dynamicFlagImportExportService {String} url for dynamicFlagImportExportService
     */
    dynamicFlagImportExportService: baseSecureRestUrl + '/flag/import-export',
    /**
     * @property eventConfigExtService {String} url to use for the eventConfigExtService.
     */
    eventConfigExtService: baseSecureRestUrl + '/event',
    /**
     * @property formFeatureConfigService {String} url for FormFeatureConfigService
     */
    formFeatureConfigService: baseSecureRestUrl + '/form/config',
    /**
     * @property formExtService {String} url to use for FormExtService
     */
    formExtService: baseSecureRestUrl + '/form',
    /**
     * @property hl7ProcessorConfigService {String} url for HL7ProcessorCongfigService
     */
    hl7ProcessorConfigService: '/hl7-processor',
    /**
     * @property importExportService {String} url to use for the ImportExportService.
     */
    hl7ProcessorConfigImportExportService: '/hl7-processor/import-export',
    /**
     * @property hl7ProcessorTemplateService {String} url for hl7ProcessorTemplateService
     */
    hl7ProcessorTemplateService: '/hl7-processor/template',
    /**
     * @property hl7MessageConfigService {String} url for Hl7MessageConfigService
     */
    hl7MessageConfigService: '/hl7-processor/message-config',
    /**
     * @property hl7FormatterService {String} url for HL7FormatterExtService
     */
    hl7FormatterService: '/hl7-processor/formatter',

    /**
     * @property hl7MappingService {String} url for HL7MappingExtService
     */
    hl7MappingService: '/hl7-processor/formatter/mapping',

    /**
     * @property hl7MappingDuplicateVecnaValuesService {String} url for hl7MappingDuplicateVecnaValuesService
     */
    hl7MappingDuplicateVecnaValuesService: '/hl7-processor/formatter/mapping/duplicateVecnaValues',

    /**
     * @property hl7MappingDuplicateClientValuesService {String} url for hl7MappingDuplicateClientValuesService
     */
    hl7MappingDuplicateClientValuesService: '/hl7-processor/formatter/mapping/duplicateClientValues',

    /**
     * @property insuranceFeatureConfigService {String} url to use for the InsuranceFeatureConfigService.
     */
    insuranceFeatureConfigService: baseSecureRestUrl + '/insurance/config',
    /**
     * @property insuranceEstimationExtService {String} url to use for the InsuranceEstimationExtService.
     */
    insuranceEstimationExtService: baseSecureRestUrl + '/insurance-estimation',
    /**
     * @property insuranceExtService {String} url
     */
    insuranceExtService: baseSecureRestUrl + '/insurance',
    /**
     * @property insurancePolicyExtService {String} url to use for the InsurancePolicyExtService.
     */
    insurancePolicyExtService: baseSecureRestUrl + '/insurance-policy',
    /**
     * @property insurancePolicyDetailsExtService {String} url to use for the InsurancePolicyDetailsExtService.
     */
    insurancePolicyDetailsExtService: baseSecureRestUrl + '/insurance-policy-details',
    /**
     * @property kioskGroupService {String} url for KioskGroup service
     */
    kioskGroupExtService: baseSecureRestUrl + '/kioskGroup',
    /**
     * @property kioskExtService {String} url for Kiosk service
     */
    kioskExtService: baseSecureRestUrl + '/kiosk',
    /**
     * @property kioskUserExtService {String} url to use for the KioskUserExtService.
     */
    kioskUserExtService: baseSecureRestUrl + '/user',
    /**
     * @property kioskUserExtService {String} url to use for the KioskUserExtService.
     */
    kioskUserGroupExtService: baseSecureRestUrl + '/group',
    /**
     * @property languageExtService {String} url for LanguageExtService
     */
    languageExtService: baseSecureRestUrl + '/language',
    /**
     * @property loginStatusExtService {String} url to use for the LoginStatusExtService.
     */
    loginStatusExtService: baseSecureRestUrl + '/loginStatus',
    /**
     * @property locationExtService {String} url to use for the LocationExtService.
     */
    locationExtService: baseRestUrl + '/location',
    /**
     * @property messagingExtService {String} url to use for the MessagingExtService.
     */
    messagingExtService: '/messaging',
    /**
     * @property messagingImportExportService {String} url to use for the messagingImportExportService.
     */
    messagingImportExportService: '/messaging/import-export',
    /**
     * @property textMessageExtService {String} url to use for the messageTemplateExtService.
     */
    messageTemplateExtService: '/messaging/template',
    /**
     * @property contactExtService {String} url to use for messaging ContactExtService.
     */
    contactExtService: '/messaging/contact',
    /**
     * @property messageExtService {String} url to use for the MessageExtService.
     */
    messageExtService: baseSecureRestUrl + '/message',
    /**
     * @property onSiteFeatureConfigService {String} url for OnsiteFeatureConfigService
     */
    onsiteFeatureConfigService: baseSecureRestUrl + '/onsite/config',
    /**
     * @property patientActivityExtService {String} url for PatientActivityExtService
     */
    patientActivityExtService: baseSecureRestUrl + '/patient-activity',
    /**
     * @property patientExtService {String} url prefix used by the PatientExtService and InsuranceExtService.
     */
    patientExtService: baseSecureRestUrl + '/patient',
    /**
     * @property patientLocationExtService {String} url prefix used by the PatientLocationExtService.
     */
    patientLocationExtService: baseSecureRestUrl + '/patientLocation',
    /**
     * @property patientLocationImportExportService {String} url prefix used by the patientLocationImportExportService.
     */
    patientLocationImportExportService: baseSecureRestUrl + '/patientLocation/import-export',
    /**
     * @property patientRegistrationExtService {String} url to use the PatientRegistrationExtService.
     */
    patientRegistrationExtService: baseSecureRestUrl + '/registration',
    /**
     * @property paymentTransactionExtService {String} url to use for the paymentTransactionExtService
     */
    paymentTransactionExtService: '/billing/payment-transaction',
    /**
     * @property printableExtService {String} url to use for the printableExtService
     */
    printableExtService: baseRestUrl + '/printable',
    /**
     * @property refundExtService {String} url to use for the RefundExtService
     */
    refundExtService: baseRestUrl + '/refund',
    /**
     * @property storedPaymentMethodExtService {String} url to use for the storedPaymentMethodExtService
     */
    storedPaymentMethodExtService: '/billing/stored-payment-method',
    /**
     * @property enumerationExtService {String} url to use for the EnumerationExtService
     */
    enumerationExtService: baseRestUrl + '/enumeration',
    /**
     * @property tabletExtService {String} url to use for the tabletExtService
     */
    tabletExtService: baseSecureRestUrl + '/tablet',
    /**
     * @property tabletGroupExtService {String} url to use for the tabletGroupExtService
     */
    tabletGroupExtService: baseSecureRestUrl + '/tablet-group',
    /**
     * @property queueExtService {String} url to use for the queueExtService
     */
    queueExtService: baseSecureRestUrl + '/queue',
    /**
     * @property paymentProcessingDeviceExtService {String} url to use for the paymentProcessingDeviceExtService.
     */
    paymentProcessingDeviceExtService: '/billing/payment/processing-device',
    /**
     * @property portalAuthenticationConfigExtService {String} url to use for the PortalAuthenticationConfigExtService.
     */
    portalAuthenticationConfigExtService: baseSecureRestUrl + '/authenticationConfig',
    /**
     * @property portalAuthenticationExtService {String} url to use for the PortalAuthenticationExtService.
     */
    portalAuthenticationExtService: baseSecureRestUrl + '/authentication',
    /**
     * @property portalBarcodeAuthenticationExtService {String} url to use for the PortalAuthenticationExtService.
     */
    portalBarcodeAuthenticationExtService: baseSecureRestUrl + '/authentication/barcode',
    /**
     * @property portalBarcodeAuthenticationExtService {String} url to use for the PortalAuthenticationExtService.
     */
    portalCreateFailedVisitForAuthenticationExtService: baseSecureRestUrl + '/authentication/errorVisit',
    /**
     * @property portalUserExtService {String} url to use for the PortalUserExtService.
     */
    portalUserExtService: baseSecureRestUrl + '/portalUser',
    /**
     * @property portalSurveyResponseExtService {String} url to use for the PortalSurveyResponseExtService.
     */
    portalSurveyResponseExtService: baseSecureRestUrl + '/portalSurveyResponse',
    /**
     * @property questionnaireFeatureConfigService {String} url for QuestionnaireFeatureConfigService
     */
    questionnaireFeatureConfigService: baseSecureRestUrl + '/questionnaire/config',
    /**
     * @property secureMessagingFeatureConfigService {String} url to use for the SecureMessagingFeatureConfigService.
     */
    secureMessagingFeatureConfigService: baseSecureRestUrl + '/secure-messaging/config',
    /**
     * @property specificAppointmentFeatureConfigService {String} url to use for the SpecificAppointmentFeatureConfigService.
     */
    specificAppointmentFeatureConfigService: baseSecureRestUrl + '/specificAppointment/config',
    /**
     * @property staticImageService {String} url to use for the staticImageService.
     */
    staticImageService: '/static-content/image/content/',
    /**
     * @property staticMessageResourcesService {String} url to use for the staticI18nService.
     */
    staticMessageResourcesService: currentApplication.staticMessagesPath,
    /**
     * @property surveyDefinitionService {String} url to use for the SurveyDefinitionService
     */
    surveyDefinitionService: '/survey/services/survey-definitions',
    /**
     * @property surveyDefinitionExtService {String} url to use for the SurveyDefinitionExtService.
     */
    surveyDefinitionExtService: baseRestUrl + '/survey',
    /**
     * @property surveyResponseExtService {String} url to use for the SurveyResponseExtService
     */
    surveyResponseExtService: baseSecureRestUrl + '/survey-response',
    /**
     * @property surveyItemTakingServiceImpl {String} url to use for the SurveyItemTakingServiceImpl.
     */
    surveyItemTakingServiceImpl: baseSecureRestUrl + '/survey-items',
    /**
     * @property surveyLanguage {String} url for getting the current language of a survey
     */
    surveyLanguage: baseSecureRestUrl + '/portalSurveyResponse/currentLanguageKey',
    /**
     * @property languageServiceImpl {String} url to use for the LanguageServiceImpl.
     */
    languageServiceImpl: baseSecureRestUrl + '/survey-languages',
    /**
     * @property tempusCredentialsExtService {String} url to use for the TempusCredentialsExtService.
     */
    tempusCredentialsExtService: '/billing/payment/tempus/credentials',
    /**
     * @property tempusPaymentDeviceExtService {String} url to use for the TempusPaymentDeviceExtService.
     */
    tempusPaymentDeviceExtService: '/billing/payment/tempus/device',
    /**
     * @property merchantAccountExtService {String} url to use for the GipMerchantAccountExtService.
     */
    gipMerchantAccountExtService: '/billing/payment/gip/merchant-account',
    /**
     * @property gipPaymentDeviceExtService {String} url to use for the GipPaymentDeviceExtService.
     */
    gipPaymentDeviceExtService: '/billing/payment/gip/device',
    /**
     * @property customImageService {String} url to use for the customImageService. Used for
     * Retrieving files by file-name rather than resource, primarily for branding customization.
     */
    customImageService: '/static-content/image/file/',
    /**
     * @property imageReferenceExtService {String} url to use for the imageReferenceExtService. Used for
     * saving new bindings for image customizations (eg: logo-aside = 'logo-aside.png'). Use
     * the image-name with a PUT request for updating a binding, plain POST request for
     * adding a new binding.
     */
    imageReferenceExtService: '/static-content/image/config',
    /**
     * @property uploadImageService {String} url to use for the uploadImageService.
     */
    uploadImageService: '/static-content/image/config/import',
    /**
     * @property cssVariableExtService {String} url to use for the cssVariableExtService.
     * Used for retrieving css variables by variable names, primarily for branding customisation.
     */
    cssVariableExtService: '/static-content/css/config',
    /**
     * @property userFeatureConfigService {String} url to use for the UserFeatureConfigService.
     */
    userFeatureConfigService: baseSecureRestUrl + '/user/config',
    /**
     * @property visitExtService {String} url to use for the visitExtService
     */
    visitExtService: baseSecureRestUrl + '/visit',
    /**
     * @property wizardPreregExtService {String} url to use for the wizardPreregExtService
     */
    wizardPreregExtService: baseSecureRestUrl + '/wizard/prereg',
    /**
     * @property paymentRedirect {String} root url for the redirect the payment page.
     */
    paymentRedirect: paymentRedirectUrl + '#patient',
    /**
     * @property payExtService {String} url for the PayExtService.
     */
    payExtService: baseSecureRestUrl + '/payment/process',

    /**
     * @property refreshUrl {String} url to refresh user authentication
     */
    refreshUrl: baseSecureRestUrl + '/authentication-token/refresh',

    /**
     * @property remoteLogUrl {String} url to update server-side logs
     */
    remoteLogUrl: baseRestUrl + '/remoteConsole',

    /**
     * @property logoutUrl {String} url to logout
     */
    logoutUrl: currentApplication.logoutUrl,

    /**
     * @property userLogEntry {String} url for the userLogEntryService
     */
    userLogEntryService: baseSecureRestUrl + '/userLogEntry'
  };
}));
